import script from "./Window01Questionnaire.vue?vue&type=script&setup=true&lang=js"
export * from "./Window01Questionnaire.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__